(() => {
    const configNode = document.getElementById('codale-analytics-config');
    if (!configNode || window.CodaleAnalytics || window.Shopify?.designMode) return;
    const config = JSON.parse(configNode.textContent);
    const debugMode = new URL(window.location.href).searchParams.get('codale_debug') === '1';
    const debugEvents = [];
    let debugOutput;
    if (debugMode) {
        const panel = document.createElement('details');
        panel.open = true;
        panel.style.cssText = 'position:fixed;right:12px;bottom:12px;z-index:2147483647;width:min(420px,calc(100vw - 24px));max-height:40vh;overflow:auto;background:#fff;color:#111;border:2px solid #276749;padding:10px;font:12px/1.4 monospace;box-shadow:0 2px 12px #0003';
        const title = document.createElement('summary');
        title.textContent = 'Codale analytics · test events';
        debugOutput = document.createElement('pre');
        debugOutput.id = 'codale-analytics-debug';
        debugOutput.style.cssText = 'white-space:pre-wrap;overflow-wrap:anywhere;margin:8px 0 0';
        debugOutput.textContent = 'Waiting for analytics consent / events…';
        panel.append(title, debugOutput);
        document.body.append(panel);
    }
    const sources = ['home_banner', 'home_best_sellers'];
    const queryKeys = ['cd_source', 'cd_pos', 'cd_id', 'cd_target', 'cd_at'];
    const pagePath = window.location.pathname;
    const pageViewId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const other = { entry_source: 'other', entry_id: 'other', entry_position: 0, entry_label: 'other', entry_target_path: '' };
    const seenImpressions = new Set();
    const seenClicks = new Set();
    const observed = new WeakSet();
    const entries = new Map();
    const visible = new Map();
    const observationTimers = new Map();
    const retentionMs = 30 * 60 * 1000;

    function localUrl(href) {
        try {
            const url = new URL(href, window.location.href);
            return url.origin === window.location.origin && /^https?:$/.test(url.protocol) ? url : null;
        } catch (_) {
            return null;
        }
    }

    function entryLabel(source, position) {
        return source === 'home_banner' ? `banner_item${position}_buy_now` : `best_sellers_card${position}`;
    }

    function readEntry() {
        const url = new URL(window.location.href);
        const source = url.searchParams.get('cd_source');
        const position = Number(url.searchParams.get('cd_pos'));
        const startedAt = Number(url.searchParams.get('cd_at')) || Date.now();
        let entry = { ...other };
        if (sources.includes(source) && Number.isInteger(position) && position > 0 && position <= 100 && Date.now() - startedAt < retentionMs) {
            const target = localUrl(url.searchParams.get('cd_target') || pagePath);
            entry = {
                entry_source: source,
                entry_position: position,
                entry_id: (url.searchParams.get('cd_id') || '').slice(0, 100),
                entry_label: entryLabel(source, position),
                entry_target_path: target?.pathname || pagePath,
                entry_started_at: startedAt
            };
        } else {
            const saved = window.history.state?.codaleEntry;
            if (saved?.path === pagePath && sources.includes(saved.entry.entry_source) && Date.now() - saved.entry.entry_started_at < retentionMs) {
                entry = saved.entry;
            }
        }
        queryKeys.forEach(key => url.searchParams.delete(key));
        try {
            window.history.replaceState({ ...window.history.state, codaleEntry: { path: pagePath, entry } }, '', url.pathname + url.search + url.hash);
        } catch (_) {}
        return entry;
    }

    const attribution = readEntry();

    function emit(event, fields = {}, ecommerce) {
        if (window.codaleAnalyticsAllowed === false) return false;
        const { entry_started_at, ...entry } = attribution;
        const payload = {
            event,
            tracking_version: 'codale_v1',
            debug_mode: debugMode ? true : undefined,
            page_type: config.pageType,
            page_path: pagePath,
            page_view_id: pageViewId,
            product_id: '',
            product_name: '',
            variant_id: '',
            entry_impressions: 0,
            entry_clicks: 0,
            entry_unique_clicks: 0,
            target_views: 0,
            successful_adds: 0,
            added_quantity: 0,
            visible_time_sec: 0,
            entry_first_click: 0,
            ...entry,
            ...fields
        };
        delete payload.entry_started_at;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        if (ecommerce) payload.ecommerce = ecommerce;
        window.dataLayer.push(payload);
        if (debugOutput) {
            debugEvents.push(payload);
            debugOutput.textContent = JSON.stringify(debugEvents.slice(-50), null, 2);
        }
        return true;
    }

    function annotateLink(link, entry) {
        const url = localUrl(link.getAttribute('href'));
        if (!url || url.pathname === pagePath) return;
        url.searchParams.set('cd_source', entry.entry_source);
        url.searchParams.set('cd_pos', entry.entry_position);
        url.searchParams.set('cd_id', entry.entry_id);
        url.searchParams.set('cd_target', entry.entry_target_path);
        if (debugMode) url.searchParams.set('codale_debug', '1');
        if (entry.entry_started_at) url.searchParams.set('cd_at', entry.entry_started_at);
        const href = url.pathname + url.search + url.hash;
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    }

    function cardItem(card) {
        return {
            item_id: card.dataset.productId,
            item_name: card.dataset.codaleProductName,
            item_variant: card.dataset.codaleVariantName,
            variant_id: card.getAttribute('product-id'),
            price: Number(card.dataset.codalePrice) / 100,
            quantity: 1,
            item_list_id: 'home_best_sellers',
            item_list_name: 'Best-selling Products',
            index: Number(card.dataset.codalePosition) - 1
        };
    }

    function entryFor(element) {
        const section = element.closest('[data-codale-entry-section]');
        if (!section) return null;
        const source = section.dataset.codaleEntrySection;
        const banner = element.closest('[data-codale-banner-id]');
        const card = element.closest('[data-codale-card]');
        if (!banner && !card) return null;
        const owner = banner || card;
        const position = Number(owner.dataset.codalePosition);
        const link = banner ? element.closest('a.slideshow__shop-btn') : card.querySelector('a.product-card-link');
        const target = localUrl(link?.getAttribute('href'));
        if (!target || !position) return null;
        return {
            entry_source: source,
            entry_position: position,
            entry_id: `${section.closest('[id]')?.id || source}:${banner ? banner.dataset.codaleBannerId : card.dataset.productId}`.slice(0, 100),
            entry_label: entryLabel(source, position),
            entry_target_path: target.pathname,
            product_id: card?.dataset.productId || '',
            product_name: card?.dataset.codaleProductName || '',
            variant_id: card?.getAttribute('product-id') || '',
            item: card ? cardItem(card) : null
        };
    }

    function entryFields(entry) {
        const { item, ...fields } = entry;
        return fields;
    }

    function entryKey(entry) {
        return `${entry.entry_id}:${entry.entry_position}`;
    }

    function isVisible(element) {
        if (window.codaleAnalyticsAllowed === false || document.visibilityState !== 'visible' || !element.isConnected) return false;
        const slide = element.closest('[data-codale-banner-id]');
        if (slide && !slide.classList.contains('swiper-slide-active')) return false;
        for (let node = element; node && node !== document.body; node = node.parentElement) {
            const style = getComputedStyle(node);
            if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
        }
        return true;
    }

    function impression(element) {
        const entry = entries.get(element);
        if (!entry || seenImpressions.has(entryKey(entry)) || !isVisible(element)) return;
        seenImpressions.add(entryKey(entry));
        emit('home_entry_impression', { ...entryFields(entry), entry_impressions: 1 });
    }

    function checkImpressions() {
        visible.forEach((ratio, element) => {
            const entry = entries.get(element);
            const eligible = entry && ratio >= 0.5 && isVisible(element) && !seenImpressions.has(entryKey(entry));
            if (!eligible && observationTimers.has(element)) {
                clearTimeout(observationTimers.get(element));
                observationTimers.delete(element);
            } else if (eligible && !observationTimers.has(element)) {
                observationTimers.set(element, setTimeout(() => {
                    observationTimers.delete(element);
                    if ((visible.get(element) || 0) >= 0.5) impression(element);
                }, 1000));
            }
        });
    }

    const intersection = 'IntersectionObserver' in window ? new IntersectionObserver(changes => {
        changes.forEach(change => visible.set(change.target, change.intersectionRatio));
        checkImpressions();
    }, { threshold: [0, 0.5, 1] }) : null;

    function registerEntries() {
        document.querySelectorAll('[data-codale-entry-section="home_banner"] [data-codale-banner-id] a.slideshow__shop-btn, [data-codale-entry-section="home_best_sellers"] [data-codale-card]').forEach(element => {
            const entry = entryFor(element);
            if (!entry) return;
            entries.set(element, entry);
            const links = element.matches('a') ? [element] : element.querySelectorAll('a[href]');
            links.forEach(link => {
                const url = localUrl(link.getAttribute('href'));
                if (element.matches('a') || /\/products\//.test(url?.pathname || '')) annotateLink(link, entry);
            });
            if (!observed.has(element)) {
                observed.add(element);
                intersection?.observe(element);
            }
        });
        checkImpressions();
    }

    function recordClick(event) {
        if (window.codaleAnalyticsAllowed === false) return;
        if ((event.type === 'auxclick' && event.button !== 1) || (event.type === 'click' && event.button !== 0)) return;
        const link = event.target.closest('a[href]');
        if (!link || event.defaultPrevented) return;
        const owner = link.matches('a.slideshow__shop-btn') ? link : link.closest('[data-codale-card]');
        if (!owner) return;
        const entry = entryFor(owner);
        const url = localUrl(link.getAttribute('href'));
        if (!entry || !url || (entry.entry_source === 'home_best_sellers' && !/\/products\//.test(url.pathname))) return;
        const slide = owner.closest('[data-codale-banner-id]');
        if (slide && !slide.classList.contains('swiper-slide-active')) return;
        annotateLink(link, entry);
        entries.set(owner, entry);
        impression(owner);
        const firstClick = !seenClicks.has(entryKey(entry));
        seenClicks.add(entryKey(entry));
        emit('home_entry_click', { ...entryFields(entry), entry_first_click: firstClick ? 1 : 0, entry_clicks: 1, entry_unique_clicks: firstClick ? 1 : 0, clicked_path: url.pathname });
    }

    function propagateCollectionEntry() {
        if (config.pageType !== 'collection' || attribution.entry_source === 'other' || attribution.entry_target_path !== pagePath) return;
        if (Date.now() - attribution.entry_started_at >= retentionMs) return;
        document.querySelectorAll('#MainContent a[href]').forEach(link => {
            if (/\/products\//.test(localUrl(link.getAttribute('href'))?.pathname || '')) annotateLink(link, attribution);
        });
    }

    function cartAdded(response, request, element) {
        try {
            if (response.status || !request?.get) return;
            const requested = new Map();
            if (request.get('id')) requested.set(String(request.get('id')), Number(request.get('quantity') || 1));
            for (const [key, value] of request.entries()) {
                const match = key.match(/^items\[(\d+)\]\[id\]$/);
                if (match) requested.set(String(value), Number(request.get(`items[${match[1]}][quantity]`) || 1));
            }
            const lines = Array.isArray(response.items) ? response.items : [response];
            const items = lines.map(line => {
                const variantId = String(line.variant_id || line.id);
                const quantity = requested.get(variantId);
                if (!quantity || quantity < 0 || !line.product_id) return null;
                return {
                    item_id: String(line.product_id),
                    item_name: line.product_title || line.title,
                    item_brand: line.vendor || '',
                    item_category: line.product_type || '',
                    item_variant: line.variant_title || '',
                    variant_id: variantId,
                    price: Number(line.final_price ?? line.price) / 100,
                    quantity
                };
            }).filter(item => item && Number.isFinite(item.price));
            if (!items.length) return;
            const card = element?.closest('[data-codale-card]');
            const entry = card ? entryFor(card) : null;
            const mainItem = items.find(item => item.variant_id === String(request.get('id'))) || items[0];
            emit('codale_add_to_cart', {
                ...(entry ? entryFields(entry) : {}),
                product_id: mainItem.item_id,
                product_name: mainItem.item_name,
                variant_id: mainItem.variant_id,
                successful_adds: 1,
                added_quantity: mainItem.quantity
            }, {
                currency: config.currency,
                value: Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100,
                items
            });
        } catch (_) {}
    }

    window.CodaleAnalytics = { cartAdded };
    document.addEventListener('click', recordClick);
    document.addEventListener('auxclick', recordClick);

    if (config.pageType === 'index' || config.pageType === 'collection') {
        registerEntries();
        propagateCollectionEntry();
        let scheduled = false;
        const observer = new MutationObserver(() => {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(() => {
                scheduled = false;
                registerEntries();
                propagateCollectionEntry();
            });
        });
        const main = document.getElementById('MainContent');
        if (main) observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'href'] });
        document.addEventListener('visibilitychange', checkImpressions);
        document.addEventListener('codale:consent', checkImpressions);
    }

    const isTarget = config.pageType === 'product' || attribution.entry_source !== 'other';
    if (isTarget) {
        const productFields = config.product ? {
            product_id: config.product.item_id,
            product_name: config.product.item_name,
            variant_id: config.product.variant_id
        } : {};
        let viewRecorded = false;
        const view = () => {
            if (viewRecorded) return;
            viewRecorded = emit('target_page_view', { ...productFields, target_views: 1 });
        };
        view();
        let visibleSince = document.visibilityState === 'visible' && window.codaleAnalyticsAllowed !== false ? performance.now() : null;
        function flush(reason) {
            if (visibleSince === null) return;
            const now = performance.now();
            const duration = Math.max(0, Math.round(now - visibleSince));
            visibleSince = document.visibilityState === 'visible' && window.codaleAnalyticsAllowed !== false && reason !== 'pagehide' ? now : null;
            if (duration) emit('target_page_engagement', { ...productFields, visible_time_msec: duration, visible_time_sec: duration / 1000, engagement_reason: reason });
        }
        setInterval(() => flush('heartbeat'), 15000);
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') flush('hidden');
            else if (visibleSince === null && window.codaleAnalyticsAllowed !== false) visibleSince = performance.now();
        });
        document.addEventListener('codale:consent', () => {
            visibleSince = document.visibilityState === 'visible' && window.codaleAnalyticsAllowed !== false ? performance.now() : null;
            view();
        });
        window.addEventListener('pagehide', () => flush('pagehide'));
        window.addEventListener('pageshow', event => {
            if (event.persisted) {
                viewRecorded = false;
                view();
                visibleSince = document.visibilityState === 'visible' && window.codaleAnalyticsAllowed !== false ? performance.now() : null;
            }
        });
    }
})();
